import { create as createStore } from 'zustand';
import { persist } from 'zustand/middleware';

import { ICalendarOptions } from '@/types';

interface IStore {
  savedCalendar: ICalendarOptions | undefined;
  setSavedCalendar: (savedCalendar?: ICalendarOptions) => void;
}

interface IStore {
  savedCalendar: ICalendarOptions | undefined;
  setSavedCalendar: (savedCalendar?: ICalendarOptions) => void;
}

export const useSavedCalendar = createStore<IStore>()(
  persist(
    set => ({
      savedCalendar: undefined,
      setSavedCalendar: (savedCalendar?: ICalendarOptions) => set({ savedCalendar })
    }),
    {
      name: 'savedCalendar'
    }
  )
);
